// node modules
import React from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
import { broker } from 'modules/TradingChart/consts';
import Validation from 'modules/Validation';
import SearchService from 'modules/Search';
// ui library
import {
  BuyIcon,
  SellIcon,
  ChartTrendingIcon,
  TableCell,
  View,
  useThemeDetector,
} from '@upstox/upstox-ui';
// utils
import { decomposeExchangeToken } from 'modules/BOD/modules/Search/utils';
// styles
import * as css from './styles';

const HoverCell: React.FC<HoverCellProps> = ({
  exchangeToken,
  isCall,
  rowType,
}) => {
  const { theme } = useStore('AppStore');
  const autoTheme = useThemeDetector();
  const currentTheme = theme === 'auto' ? autoTheme : theme;
  const { setIsMinimised, loading } = useStore('OptionChainStore');
  const { setChartSymbol } = useStore('TradingChartStore');
  const { isSegmentEnabled, isUserDormantForSegment } = useStore('UserStore');

  const { segment } = decomposeExchangeToken(exchangeToken);
  const isCommodity = Validation.isCommodity(segment);
  const isSegmentAvailable = isSegmentEnabled(segment);
  const isDormantUser = isUserDormantForSegment(segment);
  const isBuySellDisabled = !isSegmentAvailable || isDormantUser;

  const handleBuySell = async (action: 'buy' | 'sell') => {
    setIsMinimised(true);
    const optionScripData = await SearchService.searchByExchangeToken(
      exchangeToken,
    );
    const quantity = isCommodity ? 1 : optionScripData?.lotSize || 1;
    if (broker.instance) {
      broker.instance.showOrderDialog({
        symbol: exchangeToken,
        type: 2,
        side: action === 'buy' ? 1 : -1,
        qty: quantity,
        seenPrice: null,
        isAMO: false,
        instrumentKey: String(optionScripData?.instrumentKey),
      });
    }
  };

  const handleChart = () => {
    setIsMinimised(true);
    setChartSymbol(exchangeToken);
  };

  return (
    <TableCell
      className="actionCell"
      css={css.hoverCellContainer}
      cssProps={{ isCall }}
    >
      <View
        alignItems={isCall ? 'flex-start' : 'flex-end'}
        justifyContent="center"
        css={css.actionsContainer}
        cssProps={{ isCall }}
        className="actionCellContainer"
        id="actionCell"
      >
        {!loading && (
          <View
            flexDirection={isCall ? 'row' : 'row-reverse'}
            css={css.buttonsContainer}
            cssProps={{
              atm: rowType === 'atm',
              isDarkTheme: currentTheme === 'dark',
            }}
          >
            {!isBuySellDisabled && (
              <React.Fragment>
                <View onClick={() => handleBuySell('buy')} css={css.buyButton}>
                  <BuyIcon
                    css={css.buyIcon}
                    size="xxlarge"
                    className="buyIcon"
                  />
                </View>
                <View
                  onClick={() => handleBuySell('sell')}
                  css={css.sellButton}
                >
                  <SellIcon
                    css={css.sellIcon}
                    size="xxlarge"
                    className="sellIcon"
                  />
                </View>
              </React.Fragment>
            )}
            <View onClick={handleChart} css={css.chartButton}>
              <ChartTrendingIcon
                css={css.chartIcon}
                size="xxlarge"
                className="chartIcon"
              />
            </View>
          </View>
        )}
      </View>
    </TableCell>
  );
};

export default observer(HoverCell);
